<script setup lang="ts">
import type { Model as DateTimeFieldsetModel } from '@/components/fieldsets/DateTimeFieldset.vue';

import DateTimeFieldset from '@/components/fieldsets/DateTimeFieldset.vue';

export interface Model {
  requested: DateTimeFieldsetModel;
  latest: DateTimeFieldsetModel;
  estimated: DateTimeFieldsetModel;
  arrived: DateTimeFieldsetModel;
  departed: DateTimeFieldsetModel;
  pod: DateTimeFieldsetModel;
  assigned: DateTimeFieldsetModel;
}

export interface Props {
  isRequested?: boolean;
  isLatest?: boolean;
  isEstimated?: boolean;
  isArrived?: boolean;
  isDeparted?: boolean;
  isPod?: boolean;
  isAssigned?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isRequested: true,
  isLatest: true,
  isEstimated: true,
  isArrived: true,
  isDeparted: true,
  isPod: true,
  isAssigned: true,
});

const model = defineModel<Model>({
  default: () => ({}),
});
</script>

<template>
  <fieldset
    :class="$style.jobStopTimestampsFieldset"
    data-testid="jobStopTimestampsFieldset"
  >
    <div :class="$style.container">
      <div :class="$style.item">
        <DateTimeFieldset
          v-model="model.requested"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isRequested"
        >
          <template #legend>Requested</template>
        </DateTimeFieldset>
        <DateTimeFieldset
          v-model="model.latest"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isLatest"
        >
          <template #legend>Latest</template>
        </DateTimeFieldset>
        <DateTimeFieldset
          v-model="model.estimated"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isEstimated"
        >
          <template #legend>Estimated</template>
        </DateTimeFieldset>
      </div>
      <div :class="$style.item">
        <DateTimeFieldset
          v-model="model.arrived"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isArrived"
        >
          <template #legend>Arrived</template>
        </DateTimeFieldset>
        <DateTimeFieldset
          v-model="model.departed"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isDeparted"
        >
          <template #legend>Departed</template>
        </DateTimeFieldset>
        <DateTimeFieldset
          v-model="model.pod"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isPod"
        >
          <template #legend>PoD</template>
        </DateTimeFieldset>
      </div>
    </div>
    <v-divider></v-divider>
    <div :class="$style.container">
      <div :class="$style.item">
        <DateTimeFieldset
          v-model="model.assigned"
          :class="$style.dateTimeFieldset"
          :disabled="!props.isAssigned"
        >
          <template #legend>Assigned</template>
        </DateTimeFieldset>
      </div>
    </div>
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobStopTimestampsFieldset {
  border: 0;
  margin: 0;
  padding: 0;
}
  .container {
    display: flex;
    gap: variables.$pageDialogWindowPaddingX;
  }
    .item {
      width: calc(50% - #{variables.$pageDialogWindowPaddingX} / 2);
    }
      .dateTimeFieldset {
        margin-top: 10px;
      }
  .container:first-child .dateTimeFieldset:first-child {
    margin-top: 0;
  }
</style>
